"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Characteristic = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Characteristic = ({ colour = "currentcolor", size = 16, title = "Measurement Characteristic", }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true, fill: colour, stroke: colour, viewBox: "-0.5 -1.5 16 16" },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { d: "M9,12V8h3.6l3.4,3V4l-3.4,3H9V3H0v9H9z M1,4h7v7H1V4z" })));
exports.Characteristic = Characteristic;
//# sourceMappingURL=Characteristic.js.map